// removed by extract-text-webpack-plugin
module.exports = {"container":"ScaleBox__container___Vt6tg3j","point":"ScaleBox__point___2cQkJZ0","pointFocus":"ScaleBox__pointFocus___Inrmas_"};